import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Link2, X, Loader2, BookOpen } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const API = process.env.REACT_APP_BACKEND_URL;

export const AiSources = ({ links, setLinks, useKb, setUseKb, disabled }) => {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);

  const addLink = async () => {
    const value = url.trim();
    if (!value || busy) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API}/api/kb/ai/links`, { url: value },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setLinks(prev => [...prev.filter(item => item.url !== res.data.url), res.data].slice(-5));
      setUrl('');
      toast.success(`Read "${res.data.label}"`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not read that link');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-3 space-y-2.5" data-testid="kb-ai-sources">
      <button type="button" onClick={() => setUseKb(!useKb)} disabled={disabled}
        className="flex items-center gap-2 text-xs font-medium text-slate-600" data-testid="kb-ai-use-kb">
        <span className={`h-4 w-7 rounded-full transition-colors ${useKb ? 'bg-indigo-600' : 'bg-slate-300'} relative`}>
          <span className={`absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all ${useKb ? 'left-3.5' : 'left-0.5'}`} />
        </span>
        <BookOpen className="h-3.5 w-3.5" />
        Use our Officium Pages as source material
      </button>

      <div className="flex gap-2">
        <Input value={url} onChange={e => setUrl(e.target.value)} disabled={disabled || busy}
          placeholder="Paste any link to read" className="h-8 text-xs" data-testid="kb-ai-link-input"
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addLink(); } }} />
        <Button type="button" variant="outline" size="sm" className="h-8" onClick={addLink}
          disabled={disabled || busy} data-testid="kb-ai-link-add">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Link2 className="h-3.5 w-3.5" />}
        </Button>
      </div>

      {links.length > 0 && (
        <ul className="space-y-1.5">
          {links.map(link => (
            <li key={link.id} className="flex items-start justify-between gap-2 rounded-lg bg-slate-50 px-2.5 py-1.5"
              data-testid={`kb-ai-link-${link.id}`}>
              <div className="min-w-0">
                <p className="text-xs font-medium text-slate-700 truncate">{link.label}</p>
                <p className="text-[11px] text-slate-400 truncate">{link.url} · read {String(link.read_at).slice(0, 10)}</p>
              </div>
              <button onClick={() => setLinks(prev => prev.filter(item => item.id !== link.id))}
                data-testid={`kb-ai-link-remove-${link.id}`}><X className="h-3.5 w-3.5 text-slate-400" /></button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
